import React from 'react';
import useAuth from '../hooks/useAuth';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import isValidTokenMember from './isValidTokenMember';

const RequireAuth = ({ children }) => {
    return isValidTokenMember() ? children : <Navigate to="/signin" replace />;
};

RequireAuth.propTypes = {
    children: PropTypes.any,
};

export default RequireAuth;
